export const UI_CONSTANTS = {
  TOOLTIP_MESSAGE_TRUNCATE_LENGTH: 32,
} as const
